import __request__ from "routing/request";
export function listUsers(include_permissions = true, include_sessions = true) {
  return __request__("GET", "/users", null, { "include_permissions": include_permissions, "include_sessions": include_sessions }, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody) {
  return __request__("POST", "/users", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getBasicUserById(userId) {
  return __request__("GET", `/users/basic/id/${userId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getbyId(userId) {
  return __request__("GET", `/users/id/${userId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteUserById(userId) {
  return __request__("DELETE", `/users/id/${userId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "full_name", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/users/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function checkUsernameAvailability(username) {
  return __request__("GET", "/users/username_availability", null, { "username": username }, {
    "Accept": ["application/json"]
  });
}
export function changeUser(userId, JSONbody) {
  return __request__("PUT", `/users/${userId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function changePassword(userId, JSONbody) {
  return __request__("PUT", `/users/${userId}/password`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function updateAccountStatus(userId, newStatus) {
  return __request__("PUT", `/users/${userId}/status/${newStatus}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function listTokens(userId) {
  return __request__("GET", `/users/${userId}/tokens`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function revokeToken(userId, idOrToken) {
  return __request__("DELETE", `/users/${userId}/tokens/${idOrToken}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function generateNewToken(userId, name, JSONbody) {
  return __request__("POST", `/users/${userId}/tokens/${name}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteUser(username) {
  return __request__("DELETE", `/users/${username}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(username) {
  return __request__("GET", `/users/${username}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function editPermissions(username, JSONbody) {
  return __request__("PUT", `/users/${username}/permissions`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function deletePermissions(username) {
  return __request__("DELETE", `/users/${username}/permissions`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function savePreferences(username, JSONbody) {
  return __request__("PUT", `/users/${username}/preferences`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
